//
//  This file is to replicate the expand and collapse for sources and footnotes to function similar to the front-end-metrics npm package
//  https://dev.azure.com/USAFacts/frontend-library-metrics/_git/frontend-library-metrics?path=%2Fcomponents%2FSourcesAndFootnotes%2FTextExpander.js

class SourcesAndFootnotesExpander {
  constructor(node) {
    this.node = node;
    this.content = node.querySelector('[data-text-expander-content]');
    this.summary = node.querySelector('[data-text-expander-summary]');
    this.seeLess = node.querySelector('[data-text-see-less]');
    this.seeMore = node.querySelector('[data-text-see-more]');
    this.bindEvents();
  }
  bindEvents() {
    this.seeMore.addEventListener('click', () => {
      this.expand();
    });
    this.seeLess.addEventListener('click', () => {
      this.collapse();
    });
  }
  expand() {
    this.show(this.content);
    this.hide(this.summary);
  }
  collapse() {
    this.hide(this.content);
    this.show(this.summary);
  }
  show(el) {
    el.style.display = 'flex';
    el.setAttribute('aria-expanded', 'true');
  }
  hide(el) {
    el.style.display = 'none';
    el.setAttribute('aria-expanded', 'false');
  }
}
export default function initSourcesAndFootnotesExpander() {
  const expanders = document.querySelectorAll('[data-text-expander]');
  if (expanders) {
    expanders.forEach(el => new SourcesAndFootnotesExpander(el));
  }
}